import React from 'react';
import { twMerge } from 'tailwind-merge';
import arrowDecorator from '../../images/icons/icon-arrows-decorator.svg';
import Signup from '../shared/signup';
import BodyText from '../shared/richText/bodyText';
import BigText from '../shared/richText/bigText';
import Wrapper from '../shared/card/wrapper';

const CampaignSignup = ({ children, title, id, className }) => {
  return (
    <div className={twMerge('relative not-prose', className)}>
      <div className="w-full max-w-content mx-auto overflow-hidden">
        <div className="relative flex flex-col gap-6 h-full w-full border border-new-dark-30 p-6 lg:p-16">
          <Wrapper className="flex-col gap-1">
            <BigText>{title || 'Follow along'}</BigText>
            <img src={arrowDecorator} width={41} height={13} alt="Arrow Decorator" />
          </Wrapper>
          {children && <BodyText full>{children}</BodyText>}
          <Signup formStyle="home" list_id={id || ''} oneRow dark />
        </div>
      </div>
    </div>
  );
};

export default CampaignSignup;
